/**
 * @generated SignedSource<<cd0953eedbc630dcb09acd370b619ca3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeListFragment_agenda$data = {
  readonly date: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useTimeListComponentsAgendaFragment_agenda">;
  readonly " $fragmentType": "TimeListFragment_agenda";
};
export type TimeListFragment_agenda$key = {
  readonly " $data"?: TimeListFragment_agenda$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeListFragment_agenda">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeListFragment_agenda",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTimeListComponentsAgendaFragment_agenda"
    }
  ],
  "type": "Agenda",
  "abstractKey": null
};

(node as any).hash = "14c4bf90a2f14df8c34173fb0851f02e";

export default node;
